import AssignmentForm from "../../../components/admin/assignments/AssignmentForm";

function AddAssignment() {
  return (
    <main
      className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B] mt-8 space-y-6"
      style={{ width: "75%" }}
    >
      <h1 className="mb-10 text-center lws-section-title">
        Add New Assignment
      </h1>
      <span className="text-red"></span>
      <div className="max-w-3xl mx-auto">
        <AssignmentForm initialData={{}} />
      </div>
    </main>
  );
}

export default AddAssignment;
